var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428.619,
    height: 329.206,
    viewBox: "0 0 428.619 329.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2576",
    "data-name": "Groupe 2576",
    transform: "translate(379.802 327.038) rotate(-169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2947",
    "data-name": "Trac\\xE9 2947",
    d: "M374.923,172.357C259.49,253,135.833,245.274,126.053,190.035s86.419-72.406,77.495-31.546S12.011,177.688,0,0",
    transform: "translate(12.336 4.822) rotate(3)",
    fill: "none",
    stroke: "#e30613",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2948",
    "data-name": "Trac\\xE9 2948",
    d: "M0,9.833,11.8,0,22.617,11.8",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 0, 2.364)",
    fill: "none",
    stroke: "#e30613",
    strokeLinecap: "round",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.5361bf330c57976492e015ba4fc89142.svg";
export { ForwardRef as ReactComponent };